import _styled from "styled-components";
import cn from 'classnames';
import { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
/* This component doesn't use local contexts because it can be directly imported from outside */
var CircularButton = function CircularButton(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    isXxs = _ref.isXxs,
    ariaLabel = _ref['aria-label'];
  var buttonClassName = cn('button-base bg-base-main-80 rounded-full flex-shrink-0', disabled ? 'text-gray-main' : 'text-white', className);
  var buttonSize = isXxs ? 48 : 84;
  var iconSize = icon.size || (isXxs ? 32 : 56);
  var Icon = icon.component;
  return /*#__PURE__*/_jsx(_StyledButton, {
    type: "button",
    onClick: onClick,
    disabled: disabled,
    className: buttonClassName,
    "aria-label": ariaLabel,
    $_css: buttonSize,
    $_css2: buttonSize,
    $_css3: iconSize,
    $_css4: iconSize,
    children: /*#__PURE__*/_jsx(Icon, {
      className: "fill-current flex-shrink-0",
      ignoreColor: true
    })
  });
};
export default CircularButton;
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-j519ha-0"
})(["\n        width: ", "px;\n        height: ", "px;\n        & > svg {\n          width: ", "px;\n          height: ", "px;\n        }\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});